//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { imgErrorLog } from '@/utils/log'
import { handleImgSize } from '@/common/utils/map_view_data'
const MAX_ERROR_COUNT = 2

const getLittleUrl = (url) => {
    const reg = /\?x-oss-process=image\/resize,w_(\d*),h_(\d*)/
    const compressRatio = .8
    if (url.replace) {
        return url.replace(reg, (...args) => {
            if (args.length > 2) {
                return handleImgSize(Number(args[1]) * compressRatio, Number(args[2]) * compressRatio)
            }
        })
    }
    return url
}

import lazy_load_mixin from './lazy_load_mixin'
export default {
    mixins: [
        lazy_load_mixin('.common-img')
    ],
    data () {
        return {
            error_count: 0,
            task: null
        }
    },
    beforeDestroy () {
        this.task && clearTimeout(this.task)
    },
    methods: {
        handleImgError (e) {
            this.error_count++
            if (this.error_count < MAX_ERROR_COUNT) {
                this.task = setTimeout(() => {
                    this.src = getLittleUrl(this.src)
                }, 200)
            } else {
                imgErrorLog(e.mp.detail.errMsg)
            }
        },
        onLoaded (e, instance) {
            var img = e.target
            img.style.opacity = 1
        }
    },
    props: {
        mode: {
            type: String
        },
        shadow: {
            type: Boolean,
            default: true
        },
        src: {
            type: String
        },
        className: {
            type: String
        },
        shadowClass: {
            type: String
        },
        'lazy-load': {
            type: Boolean,
            default: true
        }
    }
}
